export enum ProductType {
  KKC = 'KKC',
  CL = 'CL',
  CMC = 'CMC',
}

export enum ProductName {
  KKC = 'ClearCardCredit',
  CL = 'CashLoan',
  CMC = 'CMCash',
}

export enum ThirdPartnerCode {
  MyLink = 'MyLink',
}

export enum AppName {
  CreFit = 'CreFit',
  BillManagement = 'BillManagement',
}
